import { v4 as uuid4 } from 'uuid'

export const guid = (): string => uuid4()
